export const iconFontAwesomeArrowsCircleUp = (
	<i className="fa-solid fa-circle-up"></i>
);
